if (!window.EurusUsOnlyCartGuard) {
  window.EurusUsOnlyCartGuard = (() => {
    const removedNoticeKey = 'eurus_us_only_cart_removed_notice';
    let removing = false;

    function readData() {
      const nodes = Array.from(document.querySelectorAll('.x-us-only-cart-data'));
      for (const node of nodes) {
        try {
          const data = JSON.parse(node.textContent || '{}');
          if (Array.isArray(data.items) && data.items.length) return data;
          if (data.countryIso || data.storageKey) return data;
        } catch (error) {}
      }
      const cartNoti = window.Alpine?.store('xCartNoti');
      if (cartNoti?.items?.length) {
        const items = cartNoti.items.filter((item) => {
          const props = item.properties || {};
          return props._us_only_cart === 'true' || props._us_only_cart === true || props['_us_only_cart'] === 'true';
        }).map((item) => ({
          key: item.key,
          title: item.product_title || item.title,
          quantity: item.quantity
        }));
        if (items.length) {
          return {
            countryIso: document.documentElement.dataset.countryIso || Shopify.country || '',
            usIso: 'US',
            storageKey: document.querySelector('.x-us-only-cart-data') ? null : '',
            items
          };
        }
      }
      return null;
    }

    function readSavedCountryIso(storageKey) {
      if (!storageKey) return '';
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
        return saved.countryIso || '';
      } catch (error) {
        return '';
      }
    }

    function selectedCountryIso(data) {
      if (data?.overrideCountryIso) return data.overrideCountryIso;
      const savedCountryIso = readSavedCountryIso(data?.storageKey);
      const usIso = (data?.usIso || 'US').toUpperCase();
      if (savedCountryIso && savedCountryIso.toUpperCase() !== usIso) return savedCountryIso;
      return data?.countryIso || savedCountryIso || '';
    }

    function isUnitedStates(data) {
      return selectedCountryIso(data).toUpperCase() === (data?.usIso || 'US').toUpperCase();
    }

    function sectionsToRender() {
      if (window.Alpine?.store('xCartHelper')?.getSectionsToRender) {
        return Alpine.store('xCartHelper').getSectionsToRender();
      }
      return [
        { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
        { id: 'mobile-cart-icon-bubble', selector: '#mobile-cart-icon-bubble' },
        { id: 'cart-icon-bubble-mobile-dock', selector: '#cart-icon-bubble-mobile-dock' },
        { id: 'cart-drawer', selector: '#CartDrawer' }
      ];
    }

    function noticeTarget() {
      return document.querySelector('.cart-total-summary') ||
        document.querySelector('.cart-drawer-price-total') ||
        document.getElementById('main-cart-footer') ||
        document.getElementById('main-cart-items');
    }

    function showNotice(message, tone = 'info') {
      const target = noticeTarget();
      if (!target) return;
      document.querySelectorAll('.x-us-only-cart-notice').forEach((notice) => notice.remove());
      const notice = document.createElement('div');
      notice.className = `x-us-only-cart-notice x-us-only-cart-notice-${tone}`;
      notice.setAttribute('role', 'status');
      if (tone === 'error') {
        const title = document.createElement('strong');
        title.textContent = 'Delivery unavailable';
        const body = document.createElement('span');
        body.textContent = message;
        notice.append(title, body);
      } else {
        notice.textContent = message;
      }
      target.insertAdjacentElement('afterbegin', notice);
    }

    function showStoredNotice() {
      let removedCount = 0;
      try {
        removedCount = Number(sessionStorage.getItem(removedNoticeKey) || 0);
        sessionStorage.removeItem(removedNoticeKey);
      } catch (error) {}
      if (!removedCount) return;
      const message = 'The product in your cart is available for delivery only within the United States. It was removed because your selected delivery location is outside the United States.';
      showNotice(message, 'error');
      const cartNoti = window.Alpine?.store('xCartNoti');
      if (cartNoti) {
        cartNoti.usOnlyRemovalNotice = { count: removedCount, message };
        cartNoti.open?.();
      }
    }

    async function refreshCart(sections) {
      if (window.Alpine?.store('xCartHelper')?.reRenderSections) {
        await Alpine.store('xCartHelper').reRenderSections(sections);
      } else {
        window.location.reload();
      }
    }

    async function removeUsOnlyItems(data) {
      if (removing || !data?.items?.length || isUnitedStates(data)) return;
      removing = true;
      window.updatingCart = true;
      const updates = {};
      data.items.forEach((item) => {
        if (item.key) updates[item.key] = 0;
      });
      showNotice('Removing US-only items from your cart...', 'info');

      try {
        const sections = sectionsToRender().map((section) => section.id);
        const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            updates,
            sections,
            sections_url: window.location.pathname
          })
        });
        const parsedState = await response.json();
        try {
          sessionStorage.setItem(removedNoticeKey, String(data.items.length));
        } catch (error) {}
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        await refreshCart(parsedState.sections);
        window.Alpine?.store('xCartNoti')?.applyCart?.(parsedState);
        showStoredNotice();
      } catch (error) {
        showNotice('Some US-only items cannot be shipped outside the United States. Please remove them before checkout.', 'error');
      } finally {
        window.updatingCart = false;
        removing = false;
      }
    }

    function check() {
      const data = readData();
      if (!data) return;
      if (isUnitedStates(data)) return;
      if (data.items?.length) {
        removeUsOnlyItems(data);
      } else {
        showStoredNotice();
      }
    }

    async function removeForCountry(countryIso) {
      const data = readData();
      if (!data) return;
      await removeUsOnlyItems({ ...data, overrideCountryIso: countryIso });
    }

    document.addEventListener('DOMContentLoaded', check);
    window.addEventListener('load', check);
    window.addEventListener('eurus:delivery-location:updated', (event) => {
      setTimeout(() => {
        if (event.detail?.countryIso) {
          removeForCountry(event.detail.countryIso);
        } else {
          check();
        }
      }, 0);
    });
    document.addEventListener('eurus:cart:items-changed', () => setTimeout(check, 50));

    return { check, removeForCountry };
  })();
}
